import { useCallback, useEffect, useRef, useState } from "react";

interface UseWebSocketResult {
  send: (data: unknown) => void;
  lastMessage: string | null;
  isOpen: boolean;
}

export const useWebSocket = (url: string | null): UseWebSocketResult => {
  const [lastMessage, setLastMessage] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const socketRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    if (!url) {
      setIsOpen(false);
      setLastMessage(null);
      return;
    }

    const socket = new WebSocket(url);
    socketRef.current = socket;

    socket.onopen = () => {
      setIsOpen(true);
    };
    socket.onclose = () => {
      setIsOpen(false);
    };
    socket.onmessage = (event) => {
      setLastMessage(
        typeof event.data === "string" ? event.data : String(event.data),
      );
    };

    return () => {
      socket.close();
      socketRef.current = null;
    };
  }, [url]);

  const send = useCallback((data: unknown) => {
    if (socketRef.current?.readyState === WebSocket.OPEN) {
      socketRef.current.send(JSON.stringify(data));
    }
  }, []);

  return { send, lastMessage, isOpen };
};
